import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card flex flex-col overflow-hidden group" }
const _hoisted_2 = { class: "relative bg-cream-200 h-40 sm:h-44 md:h-48 overflow-hidden" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 1,
  class: "w-full h-full flex items-center justify-center text-4xl sm:text-5xl select-none"
}
const _hoisted_5 = { class: "absolute top-3 left-3 badge text-xs" }
const _hoisted_6 = {
  key: 2,
  class: "absolute inset-0 bg-accent/50 flex items-center justify-center"
}
const _hoisted_7 = { class: "flex flex-col flex-1 p-3 sm:p-4 gap-2" }
const _hoisted_8 = { class: "font-display font-bold text-accent text-sm sm:text-base leading-snug" }
const _hoisted_9 = { class: "text-xs sm:text-sm text-accent/60 leading-relaxed flex-1" }
const _hoisted_10 = { class: "flex items-center justify-between pt-2 mt-auto" }
const _hoisted_11 = { class: "font-display font-bold text-brand text-lg" }
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlusIcon = _resolveComponent("PlusIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.item.image)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.item.image,
            alt: _ctx.item.name,
            class: "w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          }, null, 8, _hoisted_3))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.item.emoji || '🍽️'), 1)),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.item.category), 1),
      (_ctx.item.soldOut)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("span", { class: "bg-white text-accent font-bold text-sm px-4 py-1 rounded-full" }, "Sold Out", -1)
          ]))]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.item.name), 1),
      _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.item.description), 1),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.formatPrice(_ctx.item.price)), 1),
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-xs text-accent/50 ml-1" }, "Rwf", -1))
        ]),
        _createElementVNode("button", {
          class: "flex items-center gap-1 bg-brand text-white text-xs sm:text-sm font-semibold px-3 py-1.5 sm:px-4 sm:py-2 rounded-xl hover:bg-brand-600 transition-colors duration-150 disabled:opacity-40 disabled:cursor-not-allowed",
          disabled: _ctx.item.soldOut,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('add-to-cart', _ctx.item)))
        }, [
          _createVNode(_component_PlusIcon, { class: "w-4 h-4" }),
          _cache[3] || (_cache[3] = _createTextVNode(" Add ", -1))
        ], 8, _hoisted_12)
      ])
    ])
  ]))
}